import * as axiosRequests from './axiosRequests';
import { parseQuery } from 'soql-parser-js';

import { isObject, isFilledArray, sleep } from '../helpers/GeneralHelper';
import * as CookieHelper from '../helpers/CookieHelper';

import { environment } from './../../config/appEnvironment';

const { REACT_APP_STNE_API_URL } = environment;

export const sfGetLimit = 2000;

export const configureConnection = credentials => {
  const [id, token] = credentials.split(';');

  const salesforceUser = {
    credentials,
    id,
    token,
    sessionId: token,
    sessionid: token,
    authorized: true
  };

  return salesforceUser;
};

const getAuthHeader = () => ({
  token: CookieHelper.getCookie('new_ssid')
});

export const runQuery = async query => {
  const url = `${REACT_APP_STNE_API_URL}/salesforce/query`;
  const headers = getAuthHeader();

  const parsedQuery = parseQuery(query);

  const body = { parsedQuery };

  const { data } = await axiosRequests.runPostRequest(url, body, headers);
  return data;
};

export const runQueryAll = async (query, nextURL) => {
  const headers = getAuthHeader();
  let params;

  if (nextURL) {
    params = { nextURL };
  }

  const url = `${REACT_APP_STNE_API_URL}/salesforce/queryAll`;
  const parsedQuery = parseQuery(query);

  const body = { parsedQuery };

  const { data } = await axiosRequests.runPostRequest(url, body, headers, params);
  return data;
};

export const insertRecord = async (insertData, sobject) => {
  const url = `${REACT_APP_STNE_API_URL}/salesforce/insert`;
  const headers = getAuthHeader();
  const { data } = await axiosRequests.runPostRequest(url, { data: insertData, sobject }, headers);
  return { success: true, response: data };
};

export const updateRecord = async (patchData, sobject) => {
  // To disable assignment Rules
  // const optionHeader = { headers: { 'SForce-Auto-Assign': 'FALSE' } };

  const url = `${REACT_APP_STNE_API_URL}/salesforce/update`;
  const headers = getAuthHeader();
  const { Id, ...bodyData } = patchData;

  const { data } = await axiosRequests.runPatchRequest(
    url,
    { recordId: Id, data: bodyData, sobject },
    headers
  );
  return { success: true, response: data };
};

export const runGetQueryInBatchesAndCompileData = (query = () => {}, queryParams = []) => {
  return new Promise(async (resolve, reject) => {
    const data = [];

    try {
      const conditionToStop = retrievedData => retrievedData < sfGetLimit;

      let recordsRetrieved = 0;
      let loops = 0;
      while (!conditionToStop(recordsRetrieved) || loops === 0) {
        if (loops) {
          await sleep(1000);
        }

        const dataQueryParams = [...queryParams, sfGetLimit, sfGetLimit * loops++];
        const formattedDataQuery = query(...dataQueryParams);
        const { records } = await runQuery(formattedDataQuery);
        data.push(...records);

        recordsRetrieved = records.length;
      }
      resolve(data);
    } catch (err) {
      reject(err);
    }
  });
};

export const runBulkOperation = async (sfObject = '', operation = '', data = []) => {
  const url = `${REACT_APP_STNE_API_URL}/salesforce/bulk`;

  const headers = getAuthHeader();

  const body = { object: sfObject, operation, data };

  return await axiosRequests.runPostRequest(url, body, headers);
};

export const getJobInfo = async jobId => {
  const url = `${REACT_APP_STNE_API_URL}/salesforce/job`;

  const headers = getAuthHeader();

  return await axiosRequests.runGetRequest(url, { jobId }, headers);
};

export const validateSfGetResponseRecords = res =>
  Boolean(isObject(res) && isFilledArray(res.records));
